import {AxiosPromise} from "axios";
import {CONSTANT_CONFIG} from "@/constants";
import {HttpService} from "@/services/http.services";

const RESOURCE_ENDPOINT = `${CONSTANT_CONFIG.AUTH_SERVER_PREFIX}/user-filter`
const endpoints = {
  list: () => `${RESOURCE_ENDPOINT}`,
  getById: (id: any) => `${RESOURCE_ENDPOINT}/${id}`,
  isMobileEmailExist: () => `${RESOURCE_ENDPOINT}/isMobileEmailExist`,
}

export default class UserFilterApi {
  public list = (params = {}, headers = {}): AxiosPromise<any> => {
    const url = endpoints.list();
    return HttpService.get(url, params, headers);
  }
  public getById = (id: any): AxiosPromise<any> => {
    const url = endpoints.getById(id);
    return HttpService.get(url);
  }

  public isMobileEmailExist = (params = {}, headers = {}): AxiosPromise<any> => {
    const url = endpoints.isMobileEmailExist();
    return HttpService.get(url, params, headers);
  }

}
